import { useState, useEffect } from 'react';

function getIsOnline(): boolean | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return navigator.onLine;
}

/**
 * useOnline hook
 *
 * Returns true if navigator is online, false if not.
 *
 * @returns {boolean} The value of navigator.onLine
 */
export function useOnline(): boolean | null {
  const [isOnline, setIsOnline] = useState<boolean | null>(() => getIsOnline());

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const setOffline = () => setIsOnline(false);
      const setOnline = () => setIsOnline(true);

      window.addEventListener('online', setOnline);
      window.addEventListener('offline', setOffline);

      return () => {
        window.removeEventListener('online', setOnline);
        window.removeEventListener('offline', setOffline);
      };
    } else {
      console.warn('useOnline: window is undefined.');
      return;
    }
  }, []);

  return isOnline;
}
